import { NavItem } from "./types";

export function allocateNavItems(
    items: NavItem[],
    maxBarSlots: number,
): { barItems: NavItem[]; menuItems: NavItem[] } {
    const visibleItems = items.filter((item) => item.visible !== false);
    const barEligibleItems = visibleItems.filter(
        (item) => item.placement === "bar",
    );

    // The More toggle always occupies the last bar slot
    const contentSlotCount = maxBarSlots - 1;
    const barItems = barEligibleItems.slice(0, contentSlotCount);
    const overflowedItems = barEligibleItems.slice(contentSlotCount);

    const menuOnlyItems = visibleItems.filter(
        (item) => item.placement === "menu",
    );
    const beforeOverflowItems = menuOnlyItems.filter(
        (item) => item.menuSlot === "beforeOverflow",
    );
    const afterOverflowItems = menuOnlyItems.filter(
        (item) => item.menuSlot !== "beforeOverflow",
    );

    return {
        barItems,
        menuItems: [
            ...beforeOverflowItems,
            ...overflowedItems,
            ...afterOverflowItems,
        ],
    };
}

export function sumBadgeNumbers(items: NavItem[]): number[] {
    return items.reduce((totals, item) => {
        (item.badgeNumbers ?? []).forEach((badgeNumber, index) => {
            totals[index] = (totals[index] ?? 0) + badgeNumber;
        });
        return totals;
    }, [] as number[]);
}
